import { render } from "./Footer.vue?vue&type=template&id=46e506a8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./footer.css?vue&type=style&index=0&id=46e506a8&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e506a8"]])

export default __exports__